/* istanbul ignore file */
export const MOBILE_SET = 'MOBILE_SET';

export function mobileReducer(state = false, action = {}) {
  if (MOBILE_SET === action.type) {
    return action.payload;
  }
  return state;
}
